var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 96,
    viewBox: "0 0 98 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_188_20608)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.6719,
    y: 25.5,
    width: 40,
    height: 40,
    rx: 7.61905,
    fill: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_188_20608",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 35,
    width: 22,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20.9524,
    height: 20.9524,
    transform: "matrix(-1 0 0 1 63.1484 35.0234)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_188_20608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7842 51.6108H57.6829L48.7463 42.6742L49.8476 41.5729L58.7842 50.5095V51.6108ZM60.0938 52.9204V49.9656L48.5782 38.4552C48.4463 38.3353 48.3005 38.2426 48.1411 38.1773C47.9815 38.1118 47.8141 38.0791 47.6391 38.0791C47.464 38.0791 47.2945 38.1102 47.1306 38.1723C46.9664 38.2344 46.8211 38.3332 46.6947 38.4687L45.6285 39.5482C45.4931 39.6746 45.3965 39.8201 45.3389 39.9847C45.2813 40.1492 45.2525 40.3138 45.2525 40.4784C45.2525 40.654 45.2825 40.8215 45.3424 40.981C45.4023 41.1406 45.4977 41.2864 45.6285 41.4184L57.139 52.9204H60.0938ZM49.3065 42.1332L49.8476 41.5729L48.7463 42.6742L49.3065 42.1332Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_188_20608",
    x: 0.290923,
    y: 0.738096,
    width: 97.1429,
    height: 97.1429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.80952,
    dy: 3.80952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.2857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_188_20608"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_188_20608",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFav);
export default __webpack_public_path__ + "static/media/edit-fav.276b5def5363a7192ad3216dc0b1fe55.svg";
export { ForwardRef as ReactComponent };